import { forwardRef } from "react";
import { ModalRefProps, useModalContent } from "@inntechcorp/it-design";
import BackOfficeContext from "Context/BackOfficeContext";
import { AppModalData } from "Types/AppModalProps";

/**
 *
 * ### Modal Root Wrapper
 *
 * Modal'lar portal üzerinde açıldıkları için Context verilerine ulaşamaz.
 * Bu sınıf iletilen context'ler ile modal'lar için yeni context'ler yaratır.
 * Böylece modal'lar site üzerindeki tüm context verilerine ulaşabilir olur.
 *
 * it-design 4.x notu: caller verisi artık `ModalProps.data` üzerinden gelir ve
 * `useModalContent()` ile okunur. Bu wrapper prop'suz render edilir; leaf
 * modal'lara 2.x'teki prop şeklini (modalProps/context + content API) burada
 * geri kurar, ref'i de leaf'e iletir.
 *
 */
const ModalRootWrapper = forwardRef<ModalRefProps>((_props, ref) => {

  const api = useModalContent();

  const { customProps = {}, context } = (api.data ?? {}) as AppModalData;
  const { modal: ModalContent, ...restModalProps } = customProps as any;

  if ( !ModalContent ) return null;

  return (
    <div>
      <BackOfficeContext.Provider value={context}>
        <ModalContent
          ref                     = {ref}
          modalProps              = {restModalProps}
          context                 = {context}
          showAnotherModal        = {api.showAnotherModal}
          hideCurrentModal        = {api.hideCurrentModal}
          removeCurrentModal      = {api.removeCurrentModal}
          changeButtonsState      = {api.changeButtonsState}
          changeLoadingState      = {api.changeLoadingState}
          changeInnerLoadingState = {api.changeInnerLoadingState}
        />
      </BackOfficeContext.Provider>
    </div>
  );

});

export default ModalRootWrapper;
